import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { cn } from '@/lib/cn';

const LANGUAGES = [
  { code: "en", label: "EN" },
  { code: "pt", label: "PT" },
  { code: "es", label: "ES" },
] as const;

export function LanguageSwitcher({ className }: { className?: string }) {
  const { i18n, t } = useTranslation("common");
  const current = i18n.resolvedLanguage ?? "en";

  return (
    <label
      className={cn(
        "inline-flex h-9 items-center gap-1.5 rounded-md border border-border bg-background px-2 text-sm text-muted-foreground",
        className,
      )}
    >
      <Languages className="h-4 w-4" />
      <span className="sr-only">{t("common.language")}</span>
      <select
        value={current}
        onChange={(e) => void i18n.changeLanguage(e.target.value)}
        className="bg-transparent text-xs font-medium text-foreground outline-none"
        aria-label={t("common.language")}
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.label}
          </option>
        ))}
      </select>
    </label>
  );
}
